import { defaultReducers, defaultInitialState } from "../../../../../redux/_common";
import { createSlice } from "@reduxjs/toolkit";


const initialState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const articleSlice = createSlice({
  name: "article",
  initialState,
  reducers,
});

